import { useState } from "react";
import { toast } from "sonner";
import { useApi } from "@/lib/useApi";
import { api, errMsg, fcfa, fmtDateTime, ORDER_FLOW, ORDER_STATUS } from "@/lib/api";
import { Loading } from "@/components/RequireAuth";
import { StatusBadge } from "@/components/Badges";
import { OrderThread } from "@/components/OrderThread";
import { OrderSummary, OrderTimeline } from "@/pages/Orders";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const OrderDialog = ({ order, onClose, onChange }) => {
  if (!order) return null;
  const next = ORDER_FLOW[ORDER_FLOW.indexOf(order.status) + 1];
  const advance = async () => {
    try { onChange((await api.put(`/seller/orders/${order.id}/status`, { status: next })).data); toast.success("Statut mis à jour"); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className="max-h-[90vh] max-w-2xl overflow-y-auto" data-testid="seller-order-dialog">
        <DialogHeader><DialogTitle className="font-display text-2xl">{order.number}</DialogTitle></DialogHeader>
        <OrderTimeline status={order.status} />
        {next && order.status !== "annulee" && <Button onClick={advance} className="rounded-full" data-testid="order-advance-btn">Passer à : {ORDER_STATUS[next]}</Button>}
        <div className="rounded-xl bg-gray-50 p-3 text-sm">
          <p className="font-bold">Client : {order.delivery.name} · {order.delivery.phone}</p>
          <p>{order.delivery.address}, {order.delivery.city}</p>
          {order.note && <p className="mt-1 text-gray-600">Note : {order.note}</p>}
        </div>
        <OrderSummary o={order} />
        <p className="font-display font-bold">Messages avec le client</p>
        <OrderThread messages={order.messages} me="vendeur" onSend={async (text) => onChange((await api.post(`/seller/orders/${order.id}/messages`, { text })).data)} />
      </DialogContent>
    </Dialog>
  );
};

export default function SellerOrders() {
  const { data, setData } = useApi("/seller/orders");
  const [open, setOpen] = useState(null);
  const update = (o) => { setOpen(o); setData(data.map((x) => (x.id === o.id ? o : x))); };
  return (
    <div data-testid="seller-orders" className="space-y-5">
      <h1 className="font-display text-3xl font-black tracking-tight">Commandes</h1>
      {!data ? <Loading /> : data.length === 0 ? <p className="rounded-xl border border-dashed p-10 text-center text-gray-500" data-testid="seller-orders-empty">Aucune commande pour le moment.</p> : (
        <div className="divide-y rounded-xl border bg-white">
          {data.map((o) => (
            <button key={o.id} onClick={() => setOpen(o)} data-testid={`seller-order-${o.number}`} className="flex w-full flex-wrap items-center justify-between gap-2 p-4 text-left hover:bg-orange-50/40">
              <div><p className="font-display font-bold">{o.number}</p><p className="text-xs text-gray-500">{o.delivery.name} · {fmtDateTime(o.created_at)} · {o.items.length} article(s)</p></div>
              <div className="flex items-center gap-3"><StatusBadge status={o.status} /><span className="tnum font-bold">{fcfa(o.total, o.currency)}</span></div>
            </button>
          ))}
        </div>
      )}
      <OrderDialog order={open} onClose={() => setOpen(null)} onChange={update} />
    </div>
  );
}
